import React, { useEffect, useState } from "react";
import { Phone, Calculator } from "lucide-react";
import MetLogo from "./MetLogo";
import { SOUSCRIPTION_URL } from "../../content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToForm = (e) => {
    e.preventDefault();
    const el = document.getElementById("lead-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#003242]/95 backdrop-blur-xl shadow-[0_4px_20px_rgba(0,0,0,0.18)]"
          : "bg-[#003242]"
      }`}
    >
      <div className="met-container flex items-center justify-between h-20">
        <a
          href="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-3 group"
          aria-label="MET France - accueil"
        >
          <MetLogo variant="white" className="h-11 w-11" testid="nav-logo-img" />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="text-white font-extrabold tracking-tight text-base md:text-lg">MET France</span>
            <span className="text-[#88d2e7] text-[10px] md:text-[11px] font-medium tracking-[0.16em] uppercase mt-0.5">
              {`L'énergie d'entreprendre`}
            </span>
          </div>
        </a>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href={SOUSCRIPTION_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-quote-button"
            className="hidden sm:inline-flex items-center gap-2 border border-white/30 hover:border-white text-white hover:bg-white/10 font-bold text-sm md:text-base px-4 md:px-6 py-2.5 rounded-full transition-colors duration-300"
          >
            <Calculator size={16} strokeWidth={2.2} />
            <span className="hidden md:inline">Calculer mon tarif</span>
            <span className="md:hidden">Tarif</span>
          </a>
          <button
            type="button"
            onClick={scrollToForm}
            data-testid="nav-callback-button"
            className="inline-flex items-center gap-2 bg-white text-[#005870] hover:bg-[#88d2e7] hover:text-[#003242] transition-colors duration-300 font-bold text-sm md:text-base px-4 md:px-6 py-2.5 rounded-full"
          >
            <Phone size={15} strokeWidth={2.2} />
            <span className="hidden sm:inline">Me faire rappeler</span>
            <span className="sm:hidden">Rappel</span>
          </button>
        </div>
      </div>
    </header>
  );
}
